import api from '@/api/index.js'

const notification_config = {
  state: {
    loading: false,
    updating: false,
    data: [],
    notificationTypes: [],
    error: null
  },

  mutations: {
    SET_NOTIFICATION_CONFIGS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_NOTIFICATION_CONFIG_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_NOTIFICATION_CONFIGS: (state, configs) => {
      state.data = configs
      state.loading = false
    },
    SET_NOTIFICATION_CONFIG_TYPES: (state, notificationTypes) => {
      state.notificationTypes = notificationTypes
    },
    SET_NOTIFICATION_CONFIGS_ERROR: (state, error) => {
      state.error = error
    },
    SET_NOTIFICATION_CONFIG_DELETED: (state, deleted) => {
      state.data = state.data.filter(item => item.id != deleted.id);
      state.updating = false;
    },
  },

  actions: {
    GetNotificationTypes({commit}) {
      return api.get('notification-types')
        .then((response) => {
          commit('SET_NOTIFICATION_CONFIG_TYPES', response)
        })
        .catch((error) => commit('SET_NOTIFICATION_CONFIGS_ERROR', error))
    },
    LoadNotificationConfigs({commit}) {
      commit('SET_NOTIFICATION_CONFIGS_ERROR', null)
      commit('SET_NOTIFICATION_CONFIGS_LOADING', true)
      return api.get('notifications?limit=150&offset=0')
        .then((response) => {
          commit('SET_NOTIFICATION_CONFIGS', response)
        })
        .catch((error) => {
          commit('SET_NOTIFICATION_CONFIGS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_NOTIFICATION_CONFIGS_LOADING', false)
        })
    },
    CreateNotificationConfig({commit}, payload) {
      commit('SET_NOTIFICATION_CONFIG_UPDATING', true)
      commit('SET_NOTIFICATION_CONFIGS_ERROR', null)
      return api.post(`notifications`, payload)
        .then((response) => {
          commit('SET_NOTIFICATION_CONFIG_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_NOTIFICATION_CONFIGS_ERROR', error)
          commit('SET_NOTIFICATION_CONFIG_UPDATING', false)
        })
    },
    UpdateNotificationConfig({commit}, payload) {
      commit('SET_NOTIFICATION_CONFIG_UPDATING', true)
      commit('SET_NOTIFICATION_CONFIGS_ERROR', null)
      return api.put(`notifications/${payload.id}`, payload)
        .then((response) => commit('SET_NOTIFICATION_CONFIG_UPDATING', false))
        .catch((error) => {
          commit('SET_NOTIFICATION_CONFIGS_ERROR', error)
          commit('SET_NOTIFICATION_CONFIG_UPDATING', false)
        })
    },
    DeleteNotificationConfig({commit}, payload) {
      commit('SET_NOTIFICATION_CONFIG_UPDATING', true)
      commit('SET_NOTIFICATION_CONFIGS_ERROR', null)
      return api.delete(`notifications/${payload.id}`)
        .then((response) => {
          commit('SET_NOTIFICATION_CONFIG_DELETED', payload)
        })
        .catch((error) => {
          commit('SET_NOTIFICATION_CONFIGS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_NOTIFICATION_CONFIG_UPDATING', false)
        })
    }
  }
}

export default notification_config
